import { render, staticRenderFns } from "./LoveGift.vue?vue&type=template&id=0f46e976&scoped=true&"
import script from "./LoveGift.vue?vue&type=script&lang=js&"
export * from "./LoveGift.vue?vue&type=script&lang=js&"
import style0 from "./LoveGift.vue?vue&type=style&index=0&id=0f46e976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46e976",
  null
  
)

export default component.exports